/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacy } from 'app/shared/model/pharmacy.model';
import { IConsumable } from 'app/shared/model/consumable.model';
import { IPharmacySuppliers } from 'app/shared/model/pharmacy-suppliers.model';
import { IPharmacyStockBill } from 'app/shared/model/pharmacy-stock-bill.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { PharmacyAddedByType } from 'app/shared/model/enumerations/pharmacy-added-by-type.model';

export interface IPharmacyConsumableStock {
  id?: string;
  brandId?: string | null;
  stockQty?: number | null;
  manufacDate?: number | null;
  expDate?: number | null;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  active?: boolean;
  cursor?: number;
  batchNumber?: string | null;
  taxCode?: string | null;
  mrp?: number | null;
  price?: number | null;
  remainingQuantity?: number | null;
  packs?: number | null;
  HSNCode?: string | null;
  rack?: string | null;
  discount?: number | null;
  available?: boolean;
  internal?: boolean;
  shipmentItemId?: string | null;
  addedById?: string | null;
  modifiedById?: string | null;
  addedByType?: keyof typeof PharmacyAddedByType | null;
  modifiedByType?: keyof typeof PharmacyAddedByType | null;
  margin?: number | null;
  cessAmount?: number | null;
  exempted?: boolean | null;
  importDuty?: number | null;
  freeQty?: number | null;
  pharmacy?: IPharmacy;
  consumable?: IConsumable;
  supplier?: IPharmacySuppliers;
  bill?: IPharmacyStockBill | null;
  uqcType?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<IPharmacyConsumableStock> = {
  active: false,
  available: false,
  internal: false,
  exempted: false,
};
